<template>
  <div v-if="start">
    <div class="w-full">
      <vx-card>
        <vs-table
          no-data-text="У вас нет ни одного канала. Создайте новый канал, чтобы получить доступ к функционалу сервиса."
          search
          stripe
          :data="channels">
          <template slot="header">
            <vs-button :to="{name: 'channels_add'}" v-can="'company.channel.manage'">Создать канал</vs-button>
          </template>
          <template slot="thead">
            <vs-th sort-key="id">
              ID
            </vs-th>
            <vs-th sort-key="title">
              Название канала
            </vs-th>
            <vs-th sort-key="description">
              Описание
            </vs-th>
            <vs-th sort-key="whatsapp">
              <div class="text-center w-full">
                Whatsapp
              </div>
            </vs-th>
            <vs-th sort-key="telegram">
              <div class="text-center w-full">
                Telegram
              </div>
            </vs-th>
            <vs-th sort-key="actions" v-can="'company.channel.manage'">
              Действия
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
              <vs-td :data="data[indextr].id">
                {{ data[indextr].slug }}
              </vs-td>

              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>

              <vs-td :data="data[indextr].description">
                {{ data[indextr].description }}
              </vs-td>

              <vs-td>
                <div class="text-center">
                  <vs-icon icon="done" size="small" color="success"></vs-icon>
                </div>
              </vs-td>

              <vs-td>
                <div class="text-center">
                  <vs-icon icon="clear" size="small" color="danger"></vs-icon>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].actions" v-can="'company.channel.manage'">
                <div class="flex items-center justify-end">
                  <vs-button
                    type="flat"
                    size="large"
                    icon-pack="feather"
                    icon="icon-edit"
                    :to="{name: 'channels_edit', params: {channelSlug: data[indextr].slug}}"></vs-button>
                  <vs-button
                    type="flat"
                    size="large"
                    icon-pack="feather"
                    icon="icon-trash-2"
                    @click.prevent="clickOnDelete(data[indextr].slug)"></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Channels from '../../api/http/models/channels/Channels'

export default {
  data () {
    return {
      start: false,
      deletingChannel: {},
      channels: []
    }
  },
  computed: mapGetters(['authUserCompany']),
  async created () {
    const response = await Channels.getAll(this.authUserCompany.slug)
    if (response.data) {
      this.channels = response.data.reverse()
    }

    this.start = true
  },
  methods: {
    clickOnDelete (channelSlug) {
      this.deletingChannel = this.channels.find(channel => channel.slug === channelSlug)
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Вы действительно хотите удалить канал «${this.deletingChannel.name}» из Yolker?`,
        text: `Канал «${this.deletingChannel.name}» будет удален из системы.`,
        accept: this.deleteChannel,
        acceptText: 'Да, хочу',
        cancelText: 'Нет'
      })
    },
    async deleteChannel () {
      const response = await Channels.deleteOne(this.authUserCompany.slug, this.deletingChannel.slug)

      if (response.status === 'success') {
        this.channels = this.channels.filter(channel => this.deletingChannel.slug !== channel.slug)
        this.$vs.notify({
          color: 'success',
          title: 'Удаление прошло успешно',
          text: `Канал «‎‎${this.deletingChannel.name}» был удалена из системы`
        })
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Произошла ошибка',
          text: ''
        })
      }
    }
  }
}
</script>
